import { ifProp } from '../utils'

const fakeStyled = props => (strings, ...interpolations) =>
  interpolations.map(interpolation => {
    if (typeof interpolation === 'function') {
      return interpolation(props)
    }
    return interpolation
  })

describe('ifProp', () => {
  describe('key prop as first parameter', () => {
    it('should take 2 and 3 parameter as string and return if value if prop is truthy', () => {
      const props = {
        isOpen: true,
      }
      const interpolations = fakeStyled(props)`
      ${ifProp('isOpen', 'a', 'b')}
    `
      expect(interpolations[0]).toBe('a')
    })
    it('should take 2 and 3 parameter as string and return if value if prop is falsy', () => {
      const props = {
        isOpen: false,
      }
      const interpolations = fakeStyled(props)`
      ${ifProp('isOpen', 'a', 'b')}
    `
      expect(interpolations[0]).toBe('b')
    })
    it('should take 2 and 3 parameter as functions and return if value if prop is truthy', () => {
      const fakeProps = {
        isOpen: true,
        ifValue: 'a',
        elseValue: 'b',
      }
      const interpolations = fakeStyled(fakeProps)`
      ${ifProp(
        'isOpen',
        props => props.ifValue,
        props => props.elseValue,
      )}
    `
      expect(interpolations[0]).toBe('a')
    })
    it('should take 2 and 3 parameter as functions and return else value if prop is falsy', () => {
      const fakeProps = {
        isOpen: false,
        value: 'a',
      }
      const interpolations = fakeStyled(fakeProps)`
      ${ifProp('isOpen', props => props.value, 'b')}
    `
      expect(interpolations[0]).toBe('b')
    })
  })
  describe('function as first parameter', () => {
    it('should take 2 and 3 parameter as string and return if value if condition function result is truthy', () => {
      const props = {
        isOpen: true,
        isEmpty: true,
      }
      const interpolations = fakeStyled(props)`
      ${ifProp(({ isOpen, isEmpty }) => isOpen && isEmpty, 'a', 'b')}
    `
      expect(interpolations[0]).toBe('a')
    })
  })
  describe('check curried function', () => {
    it('should work fine with all non Falsy values', () => {
      const props = {
        isOpen: true,
        isEmpty: true,
      }
      const ifOpen = ifProp('isOpen')
      const ifOpenIf = ifOpen('a')
      const ifOpenElse = ifOpenIf('b')
      const interpolations = fakeStyled(props)`
      ${ifOpenElse}
    `
      expect(interpolations[0]).toBe('a')
    })
    it('should work fine with second and third argument as Falsy value', () => {
      const props = {
        isOpen: true,
        isEmpty: true,
      }
      const ifOpen = ifProp('isOpen')
      const ifOpenIf = ifOpen('a')
      const ifOpenElse = ifOpenIf('')
      const interpolations = fakeStyled(props)`
      ${ifOpenElse};
      ${ifProp(({ isEmpty }) => !isEmpty, '', 'value')};
    `
      expect(interpolations[0]).toBe('a')
      expect(interpolations[1]).toBe('value')
    })
  })
})
